export default __webpack_public_path__ + "fonts/banner-h5.6c556a9680bafa969980436bd1eb5e81.jpg";